import cautionIconDarkMode from '../../../../assets/caution-icon-dark-mode.svg';
import cautionIconLightMode from '../../../../assets/caution-icon-light-mode.svg';
import { Button } from '../../../../components/Button/';
import { useError } from '../../../../contexts/useError';
import { useTheme } from '../../../../contexts/useTheme';

import './ErrorWidget.scss';

export const ErrorWidget = ({
  buttonLink,
  buttonText,
  description,
  title,
}: {
  buttonLink: string;
  buttonText: string;
  description?: string;
  title: string;
}) => {
  const { error } = useError();
  const { theme } = useTheme();

  const cautionIcon =
    theme === 'dark' ? cautionIconDarkMode : cautionIconLightMode;

  return (
    <div className="error-widget">
      <img className="error-widget__icon" alt="Error Icon" src={cautionIcon} />
      <p className="error-widget__title" data-testid="error-widget__title">
        {title}
      </p>
      {description && (
        <p className="error-widget__description">{description}</p>
      )}
      <Button
        className="error-widget__button"
        data-testid="error-widget__button"
        link={buttonLink}
        reloadDocument={
          error ? error.statusCode >= 500 && error.statusCode <= 599 : false
        } // only add reload for internally-redirecting 5xx errors
        text={buttonText}
      />
    </div>
  );
};
